import {OEM} from '../models/oem.enum';

export const getCarTitle = (offer: {[T: string]: any}): string => {
	return offer.car_title ? offer.car_title : constructCarTitle(offer);
};

export const constructCarTitle = (offer: {[T: string]: any}): string => {
	if (shouldNotIncludeMake(offer.car_make, offer.car_model)) {
		return [offer.car_year, offer.car_model, offer.car_trim].filter(Boolean).join(' ');
	} else {
		return [offer.car_year, offer.car_make, offer.car_model, offer.car_trim].filter(Boolean).join(' ');
	}
};

const shouldNotIncludeMake = (make = '', model = ''): boolean => {
	const regexModelStartsWithMake = new RegExp('^' + make, 'i');
	return regexModelStartsWithMake.test(model) || make.toLowerCase() === OEM.WAGONEER;
};
